import fetchJSON from '@api/api_helper';

export default (_options = {}) => {
  const options = Object.assign({
    includeFolders: true,
  }, _options);

  const url = '/api/v4/organizations';

  const reqOpts = {
    params: {},
  };

  if (options.includeFolders) {
    reqOpts.params.include = 'brandfolders';
  }

  return fetchJSON(url, reqOpts).then((json) => {
    if (!json.data.length || !json.included) { return []; }

    const brandfolderAttrs = json.included.reduce((a, i) => {
      const { id, attributes } = i;
      return {
        ...a,
        [id]: {
          id,
          ...attributes,
          type: 'brandfolder',
        }
      };
    }, {});

    return json.data.map((org) => {
      const { id, attributes } = org;
      const brandfolders = org.relationships.brandfolders.data.map(({ id: bfId }) => (
        brandfolderAttrs[bfId]
      ));

      return {
        id,
        ...attributes,
        brandfolders,
        type: 'organization',
      };
    });
  });
};
